<template>
    <div>
        <div
            v-if="!isDisabled"
            class="flex justify-end w-full"
            @mousedown.stop
            @click.stop
        >
            <div v-if="isDeleteConfirmationVisible" class="flex items-center gap-1">
                <UButton
                    data-cy="confirm-delete-all-documents-button"
                    color="error"
                    size="xs"
                    class="rounded-sm"
                    :label="ctaLabel"
                    @click.stop="handleDelete"
                />
                <UButton
                    icon="i-ph-x"
                    variant="ghost"
                    size="xs"
                    class="rounded-sm"
                    color="neutral"
                    @click.stop="hideConfirm"
                />
            </div>

            <UButton
                v-else
                class="rounded-sm"
                data-cy="delete-all-documents-button"
                :label="ctaLabel"
                size="xs"
                color="neutral"
                variant="subtle"
                @click.stop="showConfirm"
            />
        </div>
    </div>
</template>

<script setup lang="ts">

import {computed} from 'vue'
import {IHeaderParams} from 'ag-grid-community'
import {useTransactionCreator} from '@/transaction/create-transaction/TransactionCreator.service'

const props = defineProps<{
    params: IHeaderParams
}>()

const {attachments} = useTransactionCreator()

const isDisabled = computed(() => attachments.value.length === 0)
const ctaLabel = computed(() => {
    const filesLength = attachments.value.length
    return filesLength > 1 ? `Slett ${filesLength} filer` : 'Slett 1 fil'
})

const handleDelete = () => {
    if (props.params.context?.deleteIncomingDocuments) {
        props.params.context.deleteIncomingDocuments()
        hideConfirm()
    }
}

const deleteConfirmationKey = 'delete-all-incoming-documents'

const isDeleteConfirmationVisible = computed(() =>
    props.params.context.deleteConfirmationState.value[deleteConfirmationKey] || false
)

const showConfirm = () => {
    props.params.context.showDeleteConfirmation(deleteConfirmationKey)
}

const hideConfirm = () => {
    props.params.context.hideDeleteConfirmation(deleteConfirmationKey)
}

</script>

<style scoped>

</style>